// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/StandingsColumnsField.tsx
import { FunctionComponent } from 'react';
import { Box, Checkbox, Flex, Text } from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { SeasonFormData } from '../../schemas';
import { STANDINGS_COLUMN_KEYS } from '../../constants';

const PREFIX = 'pages.application_season.components.season_step1.standings_columns';

/**
 * Checklist de colunas visíveis na tabela de classificação (nível temporada).
 * `position` e o nome do time ficam sempre visíveis e não aparecem aqui.
 * O valor é um objeto `{ [coluna]: boolean }` em `standings_columns`.
 * Pelo menos uma coluna precisa ficar visível (validado no schema).
 */
export const StandingsColumnsField: FunctionComponent = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const errorMessage = errors.standings_columns?.message as string | undefined;

  return (
    <Box>
      <Text fontSize="14px" fontWeight="semibold" color="gray.700" mb={1}>
        {t(`${PREFIX}.title`)}
      </Text>
      <Text fontSize="12px" color="gray.500" mb={3}>
        {t(`${PREFIX}.help`)}
      </Text>
      <Controller
        control={control}
        name="standings_columns"
        render={({ field }) => {
          const value = (field.value ?? {}) as Record<string, boolean>;
          return (
            <Flex direction="column" gap={2}>
              {STANDINGS_COLUMN_KEYS.map(key => (
                <Checkbox
                  key={key}
                  isChecked={value[key] !== false}
                  onChange={event =>
                    field.onChange({ ...value, [key]: event.target.checked })
                  }
                >
                  <Text as="span" fontSize="14px">
                    {t(`${PREFIX}.${key}`)}
                  </Text>
                </Checkbox>
              ))}
            </Flex>
          );
        }}
      />
      {errorMessage ? (
        <Text fontSize="12px" color="red.500" mt={2}>
          {errorMessage}
        </Text>
      ) : null}
    </Box>
  );
};
